import { Component, OnInit, Inject } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from "@angular/material";

import { AuthService } from "../auth/auth.service";
import { PerspectiveService } from "../perspective/perspective.service";
import { SnackBarService } from "../core/snack-bar.service";

import { ChangePasswordDialogComponent } from "../auth/change-password-dialog/change-password-dialog.component";
import { UserCredentials } from "./user-credentials.model";
import { role, Role } from "../core/role.const";
import { appVersion } from "../app-version";

@Component({
    template: require('./login.component.html'),
    styles: [require('./login.component.css')]
})
export class LoginComponent implements OnInit {
    appVersion: string = appVersion.Version;
    releaseDate: string = appVersion.ReleaseDate;
    loading: boolean;
    message: string;
    loginForm: FormGroup;

    constructor(
        private dialog: MatDialog,
        private fb: FormBuilder,
        private authService: AuthService,
        private perspectiveService: PerspectiveService,
        private snackBarService: SnackBarService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        @Inject(role) private role: Role) {

        this.loginForm = this.fb.group({
            username: ['', [Validators.required, Validators.maxLength(100)]],
            password: ['', [Validators.required, Validators.maxLength(100)]],
        });
    }

    ngOnInit() {
        // todo: fix this.. authService.logout causes 'expression changed after check' error with the toolbar? 
        // also cant seem to read the query param if it's set from the unauth interceptor?
        //this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
        //    if (params.get("unauthRedirect")) {
        //        //this.snackBarService.openSnackBar("Unauthorized - please login.");
        //        //this.authService.logout();
        //    }
        //});
    }

    changePassword(role: string): void {
        let dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
            disableClose: true,
            data: {
                // todo: when password change is required, user can just login then refresh the browser to skip updating it
                passwordChangeMandatory: true
            }
        });

        dialogRef.afterClosed().subscribe(() => {
            this.redirect(role);
        });
    }

    onSubmit(): void {
        if (this.loginForm.valid) {
            this.loading = true;
            const creds = this.loginForm.value as UserCredentials;

            this.authService.login(creds).subscribe(
                profile => {
                    if (this.authService.loggedIn()) {
                        if (profile.isRefreshPassword) {
                            this.changePassword(profile.role);
                        } else {
                            this.redirect(profile.role);
                        }
                    }
                },
                error => {
                    this.loading = false;
                    this.message = error;
                }
            );
        } else {
            this.message = "Username and password are required.";
        }
    }

    redirect(role: string): void {
        let redirect = this.authService.redirectUrl ? this.authService.redirectUrl : "/enquiries/new";

        // skip the perspective selection if one was already set in localStorage
        if (role === this.role.internalStaff && !this.perspectiveService.activeIntroducer) {
            redirect = "/perspective";
        }

        this.router.navigate([redirect]);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/login/login.component.ts